"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Player = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _settings = require("./settings.js");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _common = _interopRequireDefault(require("cccisd-survey-common/dist/styles/common.css"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Player = exports.Player = /*#__PURE__*/function (_React$Component) {
  _inherits(Player, _React$Component);
  function Player() {
    _classCallCheck(this, Player);
    return _callSuper(this, Player, arguments);
  }
  _createClass(Player, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        field = _this$props.field,
        settings = _this$props.settings,
        isMatrixMode = _this$props.isMatrixMode,
        accommodations = _this$props.accommodations,
        showQuestionNumbers = _this$props.showQuestionNumbers,
        startQuestionNumber = _this$props.startQuestionNumber;
      if (isMatrixMode) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _common["default"].lastRow
        }, /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
          field: field,
          showErrorsImmediately: false
        }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
          type: "checkbox"
        }, (0, _domOnlyProps["default"])(field))))));
      }
      var elementStyle = (0, _get2["default"])(this.props, 'playerTemplateProps.playerTemplateSettings.elementStyle');
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: [_common["default"].lastRow, _common["default"].elementWrapper, _common["default"][elementStyle]].join(' ')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].margin
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _common["default"].element + ' ' + _common["default"][elementStyle]
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: settings.question,
        registerAction: this.props.registerAction.bind(null, 1),
        setParameters: this.props.setParameters,
        accommodations: accommodations,
        prependWith: showQuestionNumbers && "".concat(startQuestionNumber, ". ")
      }), settings.description && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].description
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: settings.description
      })))), /*#__PURE__*/_react["default"].createElement(_cccisdSurveyCommon.FieldBlock, {
        field: field,
        showErrorsImmediately: false,
        size: "md"
      }, settings.visualType === 'toggle' ? /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
        value: Boolean(field.value),
        onChange: function onChange() {
          return field.onChange(!field.value);
        },
        label: /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.label,
          registerAction: this.props.registerAction.bind(null, 2),
          setParameters: this.props.setParameters,
          accommodations: accommodations
        })
      }) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "checkbox",
        style: {
          margin: '0'
        }
      }, /*#__PURE__*/_react["default"].createElement("label", null, /*#__PURE__*/_react["default"].createElement("input", _extends({
        type: "checkbox",
        onChange: function onChange() {}
      }, (0, _domOnlyProps["default"])(field))), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: settings.label,
        registerAction: this.props.registerAction.bind(null, 2),
        setParameters: this.props.setParameters,
        accommodations: accommodations
      })))));
    }
  }]);
  return Player;
}(_react["default"].Component);
_defineProperty(Player, "propTypes", {
  settings: _propTypes["default"].object,
  field: _propTypes["default"].object,
  isMatrixMode: _propTypes["default"].bool,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  accommodations: _propTypes["default"].object,
  showQuestionNumbers: _propTypes["default"].bool,
  startQuestionNumber: _propTypes["default"].number
});
_defineProperty(Player, "defaultProps", {
  isMatrixMode: false,
  registerAction: function registerAction() {},
  setParameters: function setParameters() {}
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.playerWrapper)({
  validate: _settings.validate
})(Player);